import { ArrowShareRightIcon } from '@fingertip/icons'
import Link from 'next/link'
import { useTranslation } from 'react-i18next'

import { ShareButton } from '../shared/share-button'

type Props = {
  siteSlug: string
  isMember?: boolean
}

export const SharePageButton = ({ siteSlug, isMember }: Props) => {
  const { t } = useTranslation()

  const content = (
    <div className="flex items-center gap-2 hover:text-primary transition-colors">
      <ArrowShareRightIcon className="size-4 shrink-0" />
      {t('share_page')}
    </div>
  )

  if (isMember) {
    return <Link href={`/sites/${siteSlug}/share`}>{content}</Link>
  }

  return <ShareButton>{content}</ShareButton>
}
